import React from "react";
import { Eyebrow, getClassNameFactory } from "../../../../../../";
import Tag from "./components/Tag";

var TagFooter = function TagFooter(_ref) {
  var children = _ref.children,
      title = _ref.title;
  var getClassName = getClassNameFactory("SearchResults");
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "tagFooter"
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "tagFooterTitle"
    })
  }, /*#__PURE__*/React.createElement(Eyebrow, {
    text: title
  })), /*#__PURE__*/React.createElement("ul", {
    className: getClassName({
      descendantName: "tagFooterItems"
    })
  }, children));
};

TagFooter.defaultProps = {
  title: "For:"
};
TagFooter.Tag = Tag;
export default TagFooter;